import React from 'react';
import { ConnectedAscContainer } from '../../containers';

const ConnectedAscPage = () => <ConnectedAscContainer />;

export default ConnectedAscPage;
